import { defineMessages } from 'react-intl';

const translations = {
  actions: {
    deactivate: {
      id: 'pages.serviceCosts.previewActions.deactivate',
      defaultMessage: 'Deactivate',
      description: 'Label of the deactivate action in the service costs preview',
    },
    duplicate: {
      id: 'pages.serviceCosts.previewActions.duplicate',
      defaultMessage: 'Duplicate',
      description: 'Label of the duplicate action in the service costs preview',
    },
    edit: {
      id: 'pages.serviceCosts.previewActions.edit',
      defaultMessage: 'Edit',
      description: 'Label of the edit action in the service costs preview',
    },
  },
  properties: {
    description: {
      id: 'properties.description',
      defaultMessage: 'Description',
      description: 'Label of the description property',
    },
    value: {
      id: 'properties.value',
      defaultMessage: 'Value',
      description: 'Label of the value property',
    },
    type: {
      id: 'properties.type',
      defaultMessage: 'Type',
      description: 'Label of the type property',
    },
    name: {
      id: 'properties.name',
      defaultMessage: 'Name',
      description: 'Label of the name property',
    },
    constraints: {
      id: 'properties.constraints',
      defaultMessage: 'Constraints',
      description: 'Label of the constraints property',
    },
    conditions: {
      id: 'properties.conditions',
      defaultMessage: 'Conditions',
      description: 'Label of the conditions property in the pricing rule preview',
    },
    rate: {
      id: 'properties.rate',
      defaultMessage: 'Rate',
      description: 'Label of the rate property',
    },
    countryCode: {
      id: 'properties.countryCode',
      defaultMessage: 'Country code',
      description: 'Label of the country code property',
    },
    vatSettings: {
      id: 'properties.vatSettings',
      defaultMessage: 'VAT settings',
      description: 'Label of the vat settings property',
    },
    priority: {
      id: 'properties.priority',
      defaultMessage: 'Priority',
      description: 'Label of the priority property',
    },
    activeAt: {
      id: 'properties.activeAt',
      defaultMessage: 'Active at',
      description: 'Label of the active at property',
    },
    expiresAt: {
      id: 'properties.expiresAt',
      defaultMessage: 'Expires at',
      description: 'Label of the expires at property',
    },
  },
  constraintTypes: {
    quantity: {
      id: 'serviceCostForm.constraintTypes.quantity',
      defaultMessage: 'Quantity',
      description: 'label of the constraint type quantity',
    },
    amount: {
      id: 'serviceCostForm.constraintTypes.amount',
      defaultMessage: 'Amount',
      description: 'label of the constraint type amount',
    },
    client: {
      id: 'serviceCostForm.constraintTypes.client',
      defaultMessage: 'Client',
      description: 'label of the constraint type client',
    },
    filteredAmount: {
      id: 'serviceCostForm.constraintTypes.filteredAmount',
      defaultMessage: 'Filtered amount',
      description: 'label of the constraint type filtered amount',
    },
    tags: {
      id: 'serviceCostForm.constraintTypes.tags',
      defaultMessage: 'Tags',
      description: 'label of the constraint type tags',
    },
    shipmentMethod: {
      id: 'serviceCostForm.constraintTypes.shipmentMethod',
      defaultMessage: 'Shipment method',
      description: 'label of the constraint type shipment method',
    },
    paymentMethod: {
      id: 'serviceCostForm.constraintTypes.paymentMethod',
      defaultMessage: 'Payment method',
      description: 'label of the constraint type payment method',
    },
    coupon: {
      id: 'serviceCostForm.constraintTypes.coupon',
      defaultMessage: 'Coupon',
      description: 'label of the constraint type coupon',
    },
  },
  applyToOptions: {
    linesHandling: {
      id: 'serviceCostForm.applyToOptions.linesHandling',
      defaultMessage: 'Lines handling',
      description: 'label of the form field lines handling',
    },
    linesShipping: {
      id: 'serviceCostForm.applyToOptions.linesShipping',
      defaultMessage: 'Lines shipping',
      description: 'label of the form field lines shipping',
    },
    linesCheapest: {
      id: 'serviceCostForm.applyToOptions.linesCheapest',
      defaultMessage: 'Lines cheapest',
      description: 'label of the form field lines cheapest',
    },
    linesAll: {
      id: 'serviceCostForm.applyToOptions.linesAll',
      defaultMessage: 'Lines all',
      description: 'label of the form field lines all',
    },
    filterResult: {
      id: 'serviceCostForm.applyToOptions.filterResult',
      defaultMessage: 'Filter result',
      description: 'label of the form field filter result',
    },
    filterCheapest: {
      id: 'serviceCostForm.applyToOptions.filterCheapest',
      defaultMessage: 'Filter cheapest',
      description: 'label of the form field filter cheapest',
    },
  },
  filterTypes: {
    sku: {
      id: 'serviceCostForm.filterTypes.sku',
      defaultMessage: 'SKU',
      description: 'label of the filter type sku',
    },
    filter: {
      id: 'serviceCostForm.filterTypes.filter',
      defaultMessage: 'Filter',
      description: 'label of the filter type filter',
    },
    isDiscounted: {
      id: 'serviceCostForm.filterTypes.isDiscounted',
      defaultMessage: 'Discounted',
      description: 'label of the filter type discounted',
    },
    per: {
      id: 'serviceCostForm.filterTypes.per',
      defaultMessage: 'Per',
      description: 'label of the filter type per',
    },
  },
  operators: {
    in: {
      id: 'operators.in',
      defaultMessage: 'In',
      description: 'label of the operator in',
    },
    gte: {
      id: 'operators.gte',
      defaultMessage: 'Greater than or equal to',
      description: 'label of the operator gte',
    },
    gt: {
      id: 'operators.gt',
      defaultMessage: 'Greater than',
      description: 'label of the operator gt',
    },
    lte: {
      id: 'operators.lte',
      defaultMessage: 'Lesser than or equal to',
      description: 'label of the operator lte',
    },
    lt: {
      id: 'operators.lt',
      defaultMessage: 'Lesser than',
      description: 'label of the operator lt',
    },
  },
  feedback: {
    serviceCostUpdated: {
      id: 'pages.serviceCosts.feedback.serviceCostsUpdated',
      defaultMessage: 'service updated',
      description: 'service update success message',
    },
    serviceCostNotUpdated: {
      id: 'pages.serviceCosts.feedback.serviceCostsNotUpdated',
      defaultMessage: 'service could not be updated',
      description: 'service update error message',
    },
    serviceCostDeactivated: {
      id: 'pages.serviceCosts.feedback.serviceCostsDeactivated',
      defaultMessage: 'service deactivated',
      description: 'service deactivated success message',
    },
    serviceCostNotDeactivated: {
      id: 'pages.serviceCosts.feedback.serviceCostsNotDeactivated',
      defaultMessage: 'service could not be deactivated',
      description: 'service deactivated error message',
    },
  },
};

export default defineMessages(translations);
